import { render, staticRenderFns } from "./ProjectContracts.vue?vue&type=template&id=1953ad1f&scoped=true&"
import script from "./ProjectContracts.vue?vue&type=script&lang=js&"
export * from "./ProjectContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1953ad1f",
  null
  
)

export default component.exports